<div *ngIf="!loading" class="company-feature-flags">
  <ng-container *ngIf="flags.length > 0; else noFlags">
    <div *ngFor="let item of flags" class="company-feature-flags__item">
      <label class="mb-0">
        {{item.key}}
        <span 
          class="icon-small-info"
          placement="top"
          container="body"
          [ngbTooltip]="item.description"
        ></span>
      </label>
      <div class="d-flex align-items-center">
        <vox-toggle
          class="mr-1"
          [loading]="item.loading"
          [toggleOn]="item.value"
          [config]="{isAquamarine: true, disabled: company.readOnly}"
          (toggleOnChange)="toggleFlag(item)"
        >
        </vox-toggle>
        <gdp-status-icon 
            [isEnabled]="item.is_enabled"
            placement="left" 
            [disableTooltip]="item.is_enabled" 
            [ngbTooltip]="'company.overview.feature-flags.flag-disabled-tooltip' | translate"
        ></gdp-status-icon>
      </div>
    </div>
  </ng-container>
  <ng-template #noFlags>
    <span class="d-flex align-items-center justify-content-end">-</span>
  </ng-template>
</div>
<div *ngIf="loading" class="company-feature-flags">
  <ngx-skeleton-loader 
    [theme]="{'margin-bottom': '0', 'width': '180px', 'height':'24px'}">
  </ngx-skeleton-loader>
  <ngx-skeleton-loader 
    [theme]="{'margin-bottom': '-3px', 'width': '180px', 'height':'24px'}">
  </ngx-skeleton-loader>
</div>
